<template>
  <v-dialog v-model="setdialog" width="600" persistent>
    <v-card>
      <form id="detailForm">
        <div class="data-time">
          <fieldset>
            <legend>Select Attachment</legend>
            <v-text-field
              v-model="description"
              label="Describe your attachment"
              outlined
            ></v-text-field>
            <v-file-input
              label="Upload your document here"
              outlined
              dense
              v-model="file"
            ></v-file-input>
          </fieldset>
        </div>
        <div class="actions">
          <v-btn @click="setdialog = false" class="text-red mr-6">
            Cancel
          </v-btn>
          <v-btn @click="setAttachment" color="primary">
            Add attachment
          </v-btn>
        </div>
      </form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "DelegateArrival",
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {
      file: "",
      description: "",
    };
  },
  computed: {
    setdialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("setAttachmentDialog", val);
      },
    },
  },
  methods: {
    setAttachment() {
      this.setdialog = false;
    },
  },
};
</script>
<style>
.data-time {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 8% 2%;
}

.data-time > fieldset {
  padding-left: 4%;
  border-radius: 10px;
  border: 1px solid #ccc;
  width: 90%;
}

.data-time > fieldset input {
  display: block;
  height: 4.5vh;
  width: 100%;
  border: none !important;
  outline: none !important;
}

.data-time > fieldset legend {
  font-size: 12px;
  font-weight: 600;
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 0 4% 8%;
}
</style>
